"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes an array and a value. If the value is already in the array, it's removed. Otherwise, add it.
 * Optionally a third argument can be passed to force the toggle on/off.
 *
 * @param array The array to toggle the value in.
 * @param value The value to toggle.
 * @param force (optional) Force the value on or off.
 */
function toggleInArray(array, value, force) {
    const isInArray = array.includes(value);
    const shouldBeOn = force === undefined ? !isInArray : force;
    if (shouldBeOn) {
        if (isInArray) {
            return array; // already on
        }
        else {
            return [...array, value]; // turn on
        }
    }
    else {
        // should be off
        if (isInArray) {
            return array.filter(other => other !== value); // turn off
        }
        else {
            return array; // already off
        }
    }
}
exports.default = toggleInArray;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9nZ2xlSW5BcnJheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90b2dnbGVJbkFycmF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7Ozs7Ozs7R0FPRztBQUNILFNBQXdCLGFBQWEsQ0FDbkMsS0FBVSxFQUNWLEtBQVEsRUFDUixLQUFlO0lBRWYsTUFBTSxTQUFTLEdBQUcsS0FBSyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN4QyxNQUFNLFVBQVUsR0FBRyxLQUFLLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDO0lBRTVELElBQUksVUFBVSxFQUFFO1FBQ2QsSUFBSSxTQUFTLEVBQUU7WUFDYixPQUFPLEtBQUssQ0FBQyxDQUFDLGFBQWE7U0FDNUI7YUFBTTtZQUNMLE9BQU8sQ0FBQyxHQUFHLEtBQUssRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLFVBQVU7U0FDckM7S0FDRjtTQUFNO1FBQ0wsZ0JBQWdCO1FBQ2hCLElBQUksU0FBUyxFQUFFO1lBQ2IsT0FBTyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsS0FBSyxLQUFLLEtBQUssQ0FBQyxDQUFDLENBQUMsV0FBVztTQUMzRDthQUFNO1lBQ0wsT0FBTyxLQUFLLENBQUMsQ0FBQyxjQUFjO1NBQzdCO0tBQ0Y7QUFDSCxDQUFDO0FBdEJELGdDQXNCQyJ9